import { useEffect, useState } from 'react';

const usePanelSlideOutViewManager = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const [show, setShow] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    if (open) setShow(true);
    if (!open && show) {
      setTimeout(() => !open && setShow(false), 200);
    }
  }, [open, show]);

  /**
   * Effect to manage the fade-in animation
   */
  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        setShowOverlay(true);
      }, 50);
      return () => clearTimeout(timer);
    } else {
      setShowOverlay(false);
    }
  }, [open]);

  const handleOnKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  return {
    show,
    open,
    showOverlay,
    onClose,
    onKeyDown: handleOnKeyDown,
  };
};

export default usePanelSlideOutViewManager;
